import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Loading, UserFailure, UserRepository } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

const phoneNumberRegex = /^[0-9\b]+$/;

type LoginState = {
  phoneNumber: string;
  loading: Loading;
  failure?: UserFailure;
};

const initialState: LoginState = {
  loading: "idle",
  phoneNumber: "",
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setPhoneNumber(state, { payload }: PayloadAction<string>) {
      if (payload === "" || phoneNumberRegex.test(payload)) {
        state.phoneNumber = payload;
      }
    },
    loginLoading(state) {
      state.failure = undefined;
      state.loading = "pending";
    },
    loginFailure(state, { payload }: PayloadAction<UserFailure>) {
      state.failure = payload;
      state.loading = "failed";
    },
    loginSuccess(state) {
      state.failure = undefined;
      state.loading = "succeeded";
    },
  },
});

export const { setPhoneNumber } = loginSlice.actions;
export default loginSlice.reducer;

const { loginFailure, loginLoading, loginSuccess } = loginSlice.actions;

export const loginWithPassword = (password: string): AppThunk => async (
  dispatch,
  getState
) => {
  dispatch(loginLoading());
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).loginWithPassword(getState().login.phoneNumber, password);
  res.fold(
    (l) => {
      dispatch(loginFailure(l));
    },
    (_) => {
      dispatch(loginSuccess());
    }
  );
};
